import React from "react";
import "./AboutFeatures.css";

const HRFeatures = () => {
  const features = [
    {
      id: 1,
      title: "Talent Acquisition",
      description: "Streamline your recruitment pipeline. We leverage AI-driven matching to help you find, vet, and onboard top-tier talent 3x faster than traditional methods.",
      icon: "person_search",
      color: "yellow"
    },
    {
      id: 2,
      title: "Employee Engagement",
      description: "Foster a thriving culture. Our pulse surveys and recognition tools ensure every voice is heard, boosting retention and team morale significantly.",
      icon: "groups",
      color: "purple"
    },
    {
      id: 3,
      title: "Performance Mgmt",
      description: "Move beyond annual reviews. Enable continuous feedback loops and goal tracking that align individual growth with company objectives seamlessly.",
      icon: "trending_up",
      color: "pink"
    },
    {
      id: 4,
      title: "Automated Payroll",
      description: "Eliminate errors and save time. Our integrated payroll system handles tax calculations, benefits deductions, and direct deposits automatically.",
      icon: "payments",
      color: "blue"
    },
    {
      id: 5,
      title: "People Analytics",
      description: "Make data-driven decisions. Visualize workforce trends, turnover rates, and diversity metrics with our comprehensive, real-time dashboards.",
      icon: "bar_chart",
      color: "green"
    },
    {
      id: 6,
      title: "Compliance First",
      description: "Stay compliant effortlessly. We keep your HR practices up-to-date with changing labor laws and provide enterprise-grade security for sensitive data.",
      icon: "verified_user",
      color: "orange"
    }
  ];

  return (
    <section className="hr-features-section">
      {/* Background elements */}
      <div className="background-elements">
        <div className="bg-circle bg-circle-1"></div>
        <div className="bg-circle bg-circle-2"></div>
      </div>

      <div className="container">
        {/* Header Section */}
        <div className="header-section">
          <h1 className="main-titlee">
            Why Choose <span className="primary-highlights">Our Humanex</span> Solution?
          </h1>
          <p className="subtitle">
            Here's why forward-thinking companies trust us to streamline their<br className="desktop-break" />
            human resources and empower their teams.
          </p>
        </div>

        {/* Features Grid */}
        <div className="features-grid-container">
          {/* Left Column */}
          <div className="features-column left-column">
            {features.filter(f => [1, 3, 5].includes(f.id)).map((feature) => (
              <div key={feature.id} className="feature-card-wrapper">
                <div className="sphere-container">
                  <div className={`feature-sphere sphere-${feature.color}`}></div>
                </div>
                <div className={`feature-card card-${feature.color}`}>
                  <div className={`feature-icons icon-${feature.color}`}>
                    <span className="material-icons-outlined">{feature.icon}</span>
                  </div>
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Right Column */}
          <div className="features-column right-column">
            {features.filter(f => [2, 4, 6].includes(f.id)).map((feature) => (
              <div key={feature.id} className="feature-card-wrapper">
                <div className="sphere-container">
                  <div className={`feature-sphere sphere-${feature.color}`}></div>
                </div>
                <div className={`feature-card card-${feature.color}`}>
                  <div className={`feature-icons icon-${feature.color}`}>
                    <span className="material-icons-outlined">{feature.icon}</span>
                  </div>
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* <footer className="footer">
        <div className="footer-content">
          © 2023 HR Solution Inc. All rights reserved.
        </div>
      </footer> */}
    </section>
  );
};

export default HRFeatures;